export default "__VITE_ASSET__08192466__"